<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">{{ title }}</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>
<div class="modal-body" hsDraggable="modal-dialog">
  <form>
    <nf-form-control label="Type of Transfer">
      <ng-select
        [formControl]="transferType"
        [items]="transferTypes"
        bindLabel="name"
        (change)="onTransferChange()"
        [readonly]="editMode"
        [closeOnSelect]="false"
      >
        <ng-template ng-option-tmp let-item="item">
          <div container="body" class="ellipsis">
            {{ item != null ? item.name : '' }}
          </div>
        </ng-template>
      </ng-select>
    </nf-form-control>
  </form>

  <hs-exchange-in-out-form
    *ngIf="transferType.value.id === exchangeOut.id"
    #exchange
    [accountDetails]="accountDetails"
    [editMode]="editMode"
    [reconDate]="reconDate"
    [sessionId]="sessionId"
    [sourceAccountId]="sourceAccountId"
    [aggregateAccountUnresolved]="aggregateAccountUnresolved"
    [sleeveSimpleAccount]="sleeveSimpleAccount"
    [positionData]="positionData"
    [isSourceCollateral]="isSourceCollateral"
    (dataMap)="rowNodeMap = $event"
    (basisSelected)="selectedBasis = $event"
    (currentSecurityId)="currentSecurityId = $event"
    (newSecurityId)="newSecurityId = $event"
    (inOutMvtBases)="inOutMvtBases = $event"
    (editingStarted)="editingStarted()"
    (editingStopped)="editingStopped()"
    (sleeveAccountDetails)="updateSleeveAccounts($event)"
    (valueChanged)="validate()"
    (errorDetails)="setErrorDetails($event)"
    (errorHeader)="setErrorHeader($event)"
  ></hs-exchange-in-out-form>

  <hs-transfer-in-out-form
    *ngIf="transferType.value.id === transferOut.id"
    #transfer
    [destinationAccountDetail]="destinationAccountDetail"
    [accountDetails]="accountDetails"
    [cusip]="cusip"
    [editMode]="editMode"
    [tranLinkInfo]="transInput?.tranLinkInfo"
    [reconDate]="reconDate"
    [sessionId]="sessionId"
    [sourceAccountId]="sourceAccountId"
    [aggregateAccountUnresolved]="aggregateAccountUnresolved"
    [sleeveSimpleAccount]="sleeveSimpleAccount"
    [transaction]="transaction"
    [transferPositionData]="transferPositionData"
    [mvtDataMap]="mvtDataMap"
    [isSourceCollateral]="isSourceCollateral"
    [isDestinationCollateral]="isDestinationCollateral"
    [security]="security"
    (dataMap)="rowNodeMap = $event"
    (basisSelected)="selectedBasis = $event"
    (editingStarted)="editingStarted()"
    (editingStopped)="editingStopped()"
    (currentSecurityId)="currentSecurityId = $event"
    (inOutMvtBases)="inOutMvtBases = $event"
    (sleeveAccountDetails)="updateSleeveAccounts($event)"
    (valueChanged)="validate($event)"
    (errorDetails)="setErrorDetails($event)"
    (errorHeader)="setErrorHeader($event)"
    (securityChanged)="security = $event"
  >
  </hs-transfer-in-out-form>

  <nf-form-control
    class="notes-control"
    label="Notes"
    [customErrorMessages]="getFieldValidatorFormatter('transactionNote')"
    [warnings]="noteWarning"
  >
    <textarea
      rows="3"
      class="form-control"
      id="notesText"
      [formControl]="note"
      (focus)="disableGridFocus()"
    ></textarea>
  </nf-form-control>
  <nf-form-control
    class="forbidden-control"
    label="Missing Permissions : "
    [customErrorMessages]="getFieldValidatorFormatter('forbiddenErrors')"
    [hidden]="!forbiddenErrors.errors"
  >
    <p id="forbiddenText" class="form-control">{{ forbiddenErrors.value }}</p>
  </nf-form-control>
  <div
    *ngFor="let genericWarning of genericWarnings"
    [hidden]="genericWarnings.size == 0"
  >
    <span class="mdi mdi-alert-circle-outline text-warning genericIcon"></span>
    <span class="info">{{ genericWarning }}</span>
  </div>
  <hs-loader
    class="{{ !transactionLoaded ? 'active' : '' }}"
    [loading]="!transactionLoaded"
    [label]="loadingText"
    [errorLabel]="errorText"
    [showText]="!transactionLoaded"
  ></hs-loader
  ><hs-dialog-error-details
    [errorHeader]="errorHeader"
    [errorDetails]="errorDetails"
  ></hs-dialog-error-details>
</div>

<div class="modal-footer" hsDraggable="modal-dialog">
  <div>
    <nf-checkbox
      [formControl]="clearTransaction"
      label="Clear Transaction"
    ></nf-checkbox>
  </div>
  <div>
    <span *ngIf="isValidating" class="mdi mdi-loading">validating..</span>
    <button nf-button="cancel" (click)="activeModal.dismiss()"></button>
    <button
      *ngIf="!transInput?.readOnly"
      nf-button="save"
      [disabled]="!this.isDataValid || this.isCellEditing"
      (click)="validateAndSave()"
      disableLoadingComplete
    ></button>
  </div>
</div>
